import { fromJS } from 'immutable'
import {
  ACCOUNTING_PAYING_EXPORT_REQUEST,
  ACCOUNTING_PAYING_EXPORT_SUCCESS,
  ACCOUNTING_PAYING_EXPORT_FAILURE,
  ACCOUNTING_PAYING_EXPORT_RESET,
} from '../../actions/accounting-dashboard/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case ACCOUNTING_PAYING_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case ACCOUNTING_PAYING_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case ACCOUNTING_PAYING_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case ACCOUNTING_PAYING_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/paying-export-reducer.js